module.exports = require('./lib/axios');


/*****************
 ** WEBPACK FOOTER
 ** ./~/axios/index.js
 ** module id = 24
 ** module chunks = 0
 **/